import {HeaderNameClient} from "./HeaderNameClient";
//import {HeaderNotification} from "./HeaderNotification";
//import {HeaderLogo} from "./HeaderLogo";

//import logoiProvedor from '../../../images/logo_iproveedor.png';

import "./sass/header.css";

export const Header = () =>{
    return (
        <div className="topbar">
            <HeaderNameClient/>
        </div>
    );
};

